import React, { useContext } from 'react';
import { Typography, Link } from '@one-thd/sui-atomic-components';
import { ExperienceContext, useConfigService } from '@thd-nucleus/experience-context';
import { useSpecialBuy } from '../../context/SpecialBuyProvider';
import { getPromoHeading } from '../../utils/utils';
import { FEATURE_SWITCH_KEYS } from '../../constants';

export const SimpleSpecialBuyHeader = () => {
  const {
    tagline,
    specialBuyType,
    specialBuyEndpoint
  } = useSpecialBuy();

  const isDailyDealsEnabled = useConfigService(FEATURE_SWITCH_KEYS.isDailyDealsEnabled);
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  const mobileStyles = isMobile ? 'sui-text-center sui-mt-2' : 'sui-ml-5 sui-mt-1';

  // eslint-disable-next-line max-len
  const containerStyles = 'sm:sui-justify-start sm:sui-items-end lg:sui-items-center sui-flex sui-flex-wrap sui-justify-center sui-mb-3';
  return (
    <div className={containerStyles} data-component="SimpleSpecialBuyHeader">
      <Typography variant={isMobile ? 'h3' : 'h2'}>{getPromoHeading(specialBuyType, isDailyDealsEnabled)}</Typography>
      <div className={mobileStyles}>
        <Typography
          component="span"
          weight="bold"
          color="subtle"
          variant={isMobile ? 'body-sm' : 'body-lg'}
        >
          {tagline}
        </Typography>
        <span className="sui-ml-5">
          <Link href={specialBuyEndpoint}>View All</Link>
        </span>
      </div>
    </div>
  );
};
